import React, { ReactNode, useRef } from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { Box, TextField } from "@mui/material";
import InputLabel from "../layoutComponents/InputLabel";
import { formErrorRules } from "../shared/utils/form-error-rules";
import { handleHelperText } from "../shared/utils/helper-text-handler";
import { handleEndAdornment } from "../shared/utils/end-adornment-icon-handler";
import { AutocompleteStyles } from "../shared/utils/autocomplete-styles";

interface TextFieldInputProps {
	name: string;
	control: Control;
	label: string | ReactNode;
	placeholder?: string;
	reset: (data: any) => void;
	errors: FieldErrors;
	defaultValue: string;
	setValue: (fieldName: any, value: string) => void;
	tabValue: number;
	gutterBottom?: boolean;
}

const TextFieldInput = ({
	name,
	control,
	label,
	errors,
	defaultValue,
	setValue,
	tabValue,
	placeholder,
	gutterBottom = true,
}: TextFieldInputProps) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const classes = AutocompleteStyles();

	return (
		<Box marginBottom={gutterBottom ? 2 : 0}>
			{label && <InputLabel>{label}</InputLabel>}
			<Controller
				name={name}
				defaultValue={defaultValue}
				control={control}
				rules={formErrorRules(name)}
				render={({ field: { onChange, value } }) => (
					<TextField
						error={!!errors[name]}
						fullWidth
						helperText={handleHelperText(errors, name)}
						inputRef={inputRef}
						type="text"
						onChange={onChange}
						value={value}
						InputProps={{
							classes: { root: classes.inputRoot },
							placeholder: placeholder,
							endAdornment: handleEndAdornment(errors, name, setValue, inputRef),
						}}
						inputProps={{ tabIndex: tabValue, autoCapitalize: 'none' }}
					></TextField>
				)}
			/>
		</Box>
	);
};

export default TextFieldInput;
